module.exports = __webpack_public_path__ + "img/cover_wellve.4bf0fbf2.jpg";